import { render, staticRenderFns } from "./EstoqueEtiqueta.vue?vue&type=template&id=2a3193a5&"
import script from "./EstoqueEtiqueta.vue?vue&type=script&lang=js&"
export * from "./EstoqueEtiqueta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports